export const isFullyInViewport = (
  element: HTMLElement,
  paddings?: {
    paddingTop?: number;
    paddingLeft?: number;
    paddingBottom?: number;
    paddingRight?: number;
  }
) => {
  const rect = element.getBoundingClientRect();
  const {
    paddingTop = 0,
    paddingLeft = 0,
    paddingBottom = 0,
    paddingRight = 0,
  } = paddings || {};
  return (
    rect.top >= paddingTop &&
    rect.left >= paddingLeft &&
    rect.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) -
        paddingBottom &&
    rect.right <=
      (window.innerWidth || document.documentElement.clientWidth) - paddingRight
  );
};
